export enum PropupDocumentType {
  RentalOffer = 'rental-offer',
  BuyingOffer = 'buying-offer',
  ViewingPass = 'viewing-pass',
  ExclusiveAgreement = 'exclusive-agreement',
  GeneralUpload = 'general-upload',
  SelfDeclaration = 'self-declaration',
}